import React, { useState } from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { DialogActions, DialogContent } from 'Views/Page/Content/Modal/Components';
import fr from 'facet-rest';
import { FDBox, FDPrimaryActionButton, FDPrimaryActionIconButton } from '@facet-wealth/design';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { useSnackbarContext } from 'Context/SnackbarContext';
import {
  useMetaLayoutSubmitAll,
  withMetaLayoutSubmissionContext,
} from 'Components/UI/Meta/MetaForm/Components/MetaLayoutSubmissionProvider';
import { dataAttrs } from 'Helpers/Testing';
import AccountList from './accountList';
import { metaOverrideSet } from './metaOverrideSet';

const AccountMissingInformationTemplate = () => {
  const { resource, onSubmit: submitWizard } = useMetaLayoutContext();
  const { loadModalCollectionByLink } = useModalContext();
  const [saving, setSaving] = useState(false);
  const { displayErrorMessage } = useSnackbarContext();
  const { submitAllSequentially } = useMetaLayoutSubmitAll();
  const onSubmit = async () => {
    setSaving(true);
    try {
      await submitAllSequentially();
    } catch {
      setSaving(false);
      return; // There were errors, they were shown in the individual forms, let the user fix them and move on
    }

    // Each liability has been successfully submitted, so let's submit the entire wizard and move on
    try {
      await submitWizard();
    } catch (err) {
      displayErrorMessage(err, err.errors);
    } finally {
      setSaving(false);
    }
  };

  return (
    <React.Fragment>
      <MetaControlField attr={'title'} resource={resource} metaOverrideSet={metaOverrideSet} />
      <FDBox paddingX={4}>
        <MetaControlField attr={'subtitle'} resource={resource} metaOverrideSet={metaOverrideSet} />
      </FDBox>
      <DialogContent scrollKey={resource?.type() + resource?.id()}>
        <AccountList />
      </DialogContent>
      <DialogActions>
        {resource.withRelationship(fr.relationships.previousLink.name,
          (rel) => (
            <FDPrimaryActionIconButton
              icon="chevronLeft"
              onClick={() => {
                loadModalCollectionByLink(rel.link('related').url());
              }}
            />
          ),
          () => null)}
        {resource.meta().canPost() ? <FDPrimaryActionButton {...dataAttrs('continue-btn', resource)} label={'Continue →'} onClick={onSubmit} loading={saving} /> : null}
      </DialogActions>
    </React.Fragment>
  );
};

export default withMetaLayoutSubmissionContext(AccountMissingInformationTemplate, { scrollToFirstError: true });
